
export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[75vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://static.readdy.ai/image/f384832b5a766ad07a1721f0b33de73e/bf6b2ae62da35d306a4a788944b226fd.png"
          alt="Centro de Asistencia Cuidados Humanizados Geriátrico - equipo profesional de enfermeras con pacientes"
          className="w-full h-full object-cover object-top"
          style={{ display: 'block', minWidth: '100%', minHeight: '100%' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pt-20 pb-10 sm:pt-24 sm:pb-12 md:py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full mb-5 sm:mb-8">
            <i className="ri-shield-check-line text-uri-teal text-sm"></i>
            <span className="text-xs sm:text-sm font-medium text-gray-900">Profesionales de Salud Certificados • Disponible 24/7</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Asistencia Profesional de Salud
          </h2>
          
          <p className="text-base sm:text-xl md:text-2xl text-white/95 mb-6 sm:mb-12 max-w-3xl mx-auto leading-relaxed">
            Cuidado humanizado para sus seres queridos con servicios especializados de asistencia residencial y hospitalaria adaptados a sus necesidades únicas
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-12">
            <button 
              onClick={() => scrollToSection('services')}
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-uri-teal text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-uri-teal-dark transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-heart-line mr-2"></i>
              Cuidado Residencial
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-uri-teal text-sm sm:text-base font-semibold rounded-lg hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-white cursor-pointer whitespace-nowrap"
            >
              <i className="ri-hospital-line mr-2"></i>
              Asistencia Hospitalaria
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="hidden sm:flex flex-wrap items-center justify-center gap-6 sm:gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-xl sm:text-2xl"></i>
              <span className="text-xs sm:text-sm font-medium">15+ Años de Experiencia</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-user-heart-line text-xl sm:text-2xl"></i>
              <span className="text-xs sm:text-sm font-medium">5,000+ Pacientes Atendidos</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-xl sm:text-2xl text-yellow-400"></i>
              <span className="text-xs sm:text-sm font-medium">4.9/5 Calificación</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button 
          onClick={() => scrollToSection('services')}
          className="w-10 h-10 rounded-full border-2 border-white/50 flex items-center justify-center animate-bounce hover:border-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </button>
      </div>
    </section>
  );
}
